import React from 'react'
import { FormLabel } from 'hhsoig-design-system-core'

export const HorizontalField = ({ name, label, inputRef, ...props }) => (
  <div className="ds-l-form-row ds-u-align-items--center">
    <div className="ds-l-col--auto ds-u-padding-left--1">
      <input
        className="ds-c-field"
        id={`input-${name}`}
        name={name}
        ref={inputRef}
        {...props}
      />
    </div>
    <div className="ds-l-col--auto ds-u-margin-top--0 ds-u-padding-left--0 ds-u-margin-right--3">
      <FormLabel
        fieldId="input-height__feet"
        className="ds-u-margin-top--0"
        labelClassName="ds-u-font-weight--normal"
      >
        {label}
      </FormLabel>
    </div>
  </div>
)
